export default {
	address: 'Address',
	addToCart: 'Add to cart',
	belgium: 'Belgium',
	cart: 'Cart',
	city: 'City',
	country: 'Country',
	currentPage: 'current',
	deliveryDate: 'Delivery Date',
	deliveryFormat: '[Week] w YYYY',
	email: 'Email',
	eta: 'ETA:',
	etaFormat: '[Week] w',
	firstEta: 'One or more of the items in your cart are currently not in stock. The first available delivery week is {{week}}.',
	firstEtaFallback: 'unknown',
	firstEtaFormat: '[week] w',
	friend: 'Who do I know at PTMD?',
	germany: 'Germany',
	itemNotFound: 'Item not found',
	itemUnavailable: 'This item is currently unavailable',
	name: 'Name',
	netherlands: 'The Netherlands',
	oops: 'Oops...',
	order: 'Place order',
	orderDetails: 'Order details',
	phone: 'Phone number',
	placeWishlist: 'Place wishlist',
	pleaseTilt: 'Please tilt your device.',
	postalCode: 'Postal code',
	stock: 'Stock: {{count}}',
	'stock_interval': '(999999){Stock: Available soon};',
	thanksForYourOrder: 'Thank you for your Click & Collect order. Your wishlist will now be sent to {{customer}}. {{customer}} will contact you as soon as possible.',
	toggleFullScreen: 'Toggle fullscreen',
	total: 'Total:',
	useSafari: 'Please use Safari as your browser.',
	yourShop: 'Your shop: {{customer}}'
};
